import React from 'react';
import Modal from './ui/Modal';

const VersionChangeModal = ({ isOpen, onClose, changes }) => {
    if (!isOpen || !changes || changes.length === 0) return null;

    const getChangeTypeColor = (type) => {
        switch (type) {
            case 'feature':
                return 'bg-green-100 text-green-800';
            case 'fix':
                return 'bg-blue-100 text-blue-800';
            case 'improvement':
                return 'bg-yellow-100 text-yellow-800';
            case 'breaking':
                return 'bg-red-100 text-red-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    const getChangeTypeIcon = (type) => {
        switch (type) {
            case 'feature':
                return '✨';
            case 'fix':
                return '🐛';
            case 'improvement':
                return '⚡';
            case 'breaking':
                return '⚠️';
            default:
                return '📝';
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={`Your Pi-Schedule has been updated to ${changes && changes.length > 0 ? changes[0].version : ''}!`}
        >
            <div className="space-y-6">
                <div className="text-gray-600 mb-4">
                    Here are the latest updates and improvements to Pi-Schedule:
                </div>

                {changes.map((version, versionIndex) => (
                    <div key={version.version} className="border-b pb-4 last:border-b-0">
                        <div className="flex items-center justify-between mb-3">
                            <h3 className="text-lg font-semibold text-gray-800">
                                Version {version.version}
                                {versionIndex === 0 && (
                                    <span className="ml-2 px-2 py-0.5 rounded bg-blue-100 text-blue-800 text-xs font-medium">
                                        Current
                                    </span>
                                )}
                            </h3>
                            <span className="text-sm text-gray-500">
                                {new Date(version.releaseDate).toLocaleDateString()}
                            </span>
                        </div>

                        <ul className="list-disc pl-6 space-y-2">
                            {version.changes.map((change, changeIndex) => (
                                <li key={changeIndex} className="text-gray-700 mt-1">
                                    <span className={change.importance === 'high' ? 'font-bold' : ''}>
                                        {change.description}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}

                <div className="flex justify-end pt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Got it!
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default VersionChangeModal;